import '../sass/all.scss'; // import scss
import 'bootstrap';
import 'slick-carousel';
import 'jquery-validation'
import './app/class.audio';
import './app/class.video';
import './app/class.popup';
import { ajax } from 'jquery';
const Main = () => {
    let ajaxCalling = false;
    let pageIndex = 1;
    let lastId = 0;
    let pageSize = 10;
    let total = 0;
    const getBlockParticipant = () => {
        console.log('getBlockParticipant-bf');
        if (!ajaxCalling) {
            console.log('getBlockParticipant-in-ajaxCalling');
            $('.loading').show();
            ajaxCalling = true;
            $.ajax({
                type: 'GET',
                url: `${_appSettings.base_url}/getBlockParticipant`,
                data: { pageIndex, pageSize, lastId },
                success: function (response) {
                    if (response.success) {
                        pageIndex = pageIndex + 1;
                        total = response.total;
                        $('.container.container-custom').append(response.html);
                        lastId = response.lastId;
                        SE.clsVideo.createHeigh()

                    }
                    $('.loading').hide();
                    ajaxCalling = false;
                },
                error: function (jqXHR) {
                    ajaxCalling = false;
                },
            })
        }
    }
    const initEvent = () => {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
        })
        getBlockParticipant();
        $(window).on("scroll", () => {
            const y_scroll_pos = window.pageYOffset;
            const lastItemPos = $('.container.container-custom > div').last().offset().top;
            if (y_scroll_pos + 500 > lastItemPos && !ajaxCalling && $('.container.container-custom > div').length - 2 < total) {
                getBlockParticipant();
            }
        });
        $('.featured-products-slider').slick({
            dots: true,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            swipe: true,
        });
    }
    const sendFormData = (key, data) => {
        if (!ajaxCalling) {
            ajaxCalling = true;
            $.ajax({
                type: "POST",
                url: `${_appSettings.base_url}/participants/store`,
                data: data,
                cache: false,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response && response.success) {
                        // reload the items
                        let elements = document.querySelectorAll('.container.container-custom > div');
                        for(var i = 2; i < elements.length; i++){
                            elements[i].remove();
                        }
                        pageIndex = 1;
                        lastId = 0;
                        total = 0;
                        ajaxCalling = false;
                        getBlockParticipant();
                    } else if (response.error) {

                    }
                    $(`#${$(key).parent()[0].id}`).hide();
                    ajaxCalling = false;
                },
                error: function (jqXHR) {
                    ajaxCalling = false;
                },
            });
        }
    }
    const formValidate = () => {
        jQuery.validator.addMethod("equal", function (value, element, params) {
            return this.optional(element) || value == params[0];
        }, jQuery.validator.format("Please enter the correct value for {0} + {1}"));

        const formRules = {
            '#form-popup-image': {
                rules: {
                    type: {
                        required: true,
                        equal: "2"
                    },
                    image: {
                        required: true
                    },
                },
            },
            '#form-popup-music': {
                rules: {
                    type: {
                        required: true,
                        equal: "4"
                    },
                    url: {
                        required: true,
                        url: true
                    }
                }
            },
            '#form-popup-text': {
                rules: {
                    type: {
                        required: true,
                        equal: "1"
                    },
                    name: {
                        required: false,
                        maxlength: 255
                    },
                    message: {
                        required: true,
                        maxlength: 255
                    }
                }
            },
            '#form-popup-video': {
                rules: {
                    type: {
                        required: true,
                        equal: "3"
                    },
                    url: {
                        required: true,
                        url: true
                    }
                }
            },
        }
        Object.entries(formRules).map(([key, rules]) => {
            $(key).validate({
                ...rules,
                errorPlacement: function (error, element) { },
                submitHandler: function (form) {
                    let data = new FormData(form);
                    // $(form).serializeArray().map(({ name, value }) => {
                    //     data.append(name, value);
                    // })
                    // console.log(form)
                    // console.log($(form).serializeArray())
                    sendFormData(key, data);
                    $(key)[0].reset()
                },
                highlight: function (element, errorClass, validClass) {
                    if ($(element).attr('name') == "image") {
                        $(element).parents('.group-upload').addClass(errorClass).removeClass(validClass);
                    } else {
                        $(element).addClass(errorClass).removeClass(validClass);
                    }
                    // $(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    if ($(element).attr('name') == "image") {
                        $(element).parents('.group-upload').removeClass(errorClass).addClass(validClass);
                    } else {
                        $(element).removeClass(errorClass).addClass(validClass);
                    }
                    // $(element).removeClass(errorClass).addClass(validClass);
                },
                invalidHandler: function (event, validator) {
                },
                focusInvalid: true,
            });
        })
    }

    function file_init() {
        var group = document.querySelector(".group-upload");
        var input = group.querySelector("input");
        var content = group.querySelector(".upload");
        var span = content.querySelector("span");

        input.addEventListener("change",function(e){
        var reader = new FileReader();
        reader.onload = function(e){
            group.classList.add("selected");
            span.style.opacity = 0;
            content.style.backgroundImage = "url("+e.target.result+")";
        }
        reader.readAsDataURL(input.files[0]);
        });
    }

    const init = () => {
        console.log('Main init');
        initEvent()
        formValidate()
        file_init();
        console.log('V1.00.1');
    }
    return {
        init
    }
};

$(document).ready(function () {
    const main = new Main();
    main.init();
})
